<div class="container my-5">
  <h2 class="mb-4 text-primary">Đơn hàng đã nhận</h2>
  <div *ngIf="orders$ | async as orders">
    <div *ngIf="orders.length > 0; else emptyState">
      <div class="table-responsive">
        <table class="table table-hover align-middle shadow-sm rounded">
          <thead class="table-light">
            <tr>
              <th>Mã nông phẩm</th>
              <th>Giống</th>
              <th>Khối lượng</th>
              <th>Giá mua</th>
              <th>Ngày nhận</th>
              <th>Hành động</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let order of orders">
              <td>{{ order.pigNumber }}</td>
              <td>{{ order.breed }}</td>
              <td>{{ order.weight }} {{ order.unit }}</td>
              <td>{{ order.purchasedPrice | number }} đ</td>
              <td>
                {{ order.receivedAt?.toDate ? (order.receivedAt.toDate() | date:'short') : (order.receivedAt | date:'short') }}
              </td>
              <td>
                <button class="btn btn-outline-primary btn-sm" 
                  (click)="
                    viewDetail(order);
                    docModal.open(selectedDocModal, { size: 'lg', centered: true })
                  "
                >
                  <i class="fa fa-eye"></i> Chi tiết
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <ng-template #emptyState>
      <div class="text-center text-muted py-5">
        <i class="fa fa-inbox fa-3x mb-3"></i>
        <p>Bạn chưa có đơn hàng nào.</p>
      </div>
    </ng-template>

    <ng-template #selectedDocModal let-modal>
      <div class="modal-header">
        <h4 class="modal-title">
          {{ selectedPig?.pigNumber }}
        </h4>
        <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
      </div>
      <div class="modal-body" style="max-height: 75vh; overflow-y: auto">
        <div *ngIf="selectedPig">
          <h6><b>Giống:</b></h6>
          <span>{{ selectedPig.breed }}</span>
          <br />
          <h6><b>Khối lượng:</b></h6>
          <span>{{ selectedPig.weight }} {{ selectedPig.unit }}</span>
          <br />
          <h6><b>Giá mua:</b></h6>
          <span>{{ selectedPig.purchasedPrice | number }} đ</span>
          <br />
        </div>
      </div>
      <div class="modal-footer">
        <button 
          class="btn btn-outline-warning"
          (click)="showPaymentOptions()"
          [disabled]="isProcessingPayment"
        >
          <span *ngIf="isProcessingPayment" class="spinner-border spinner-border-sm me-2"></span>
          {{ isProcessingPayment ? 'Đang xử lý...' : 'Thanh toán' }}
        </button>
        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="modal.dismiss()"
        >
          Đóng
        </button>
      </div>
    </ng-template>
  </div>
</div>
